import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {environment} from "@environment";

@Injectable({ providedIn:'root' })
export class EnvironmentService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  }

  getApiUrl(): string {
    if (isPlatformBrowser(this.platformId)) {
      return environment.apiUrl;
    } else {
      return environment.internalServicesAddress;
    }
  }
}
